import { Typography, Box, Button } from "@mui/material";

export default function ProductCard({ cake ,index,show,onOpen}) {
  return (
    <Box
      onClick={() => onOpen(cake)}
      sx={{
        height: "400px",
        width: "310px",
        background: "white",
        borderRadius: "17px",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        cursor: "pointer",
        transition: "all 0.55s ease",
        boxShadow: "0 6px 18px rgba(0,0,0,0.08)",
        opacity: show?1: 0,
        transform: show
          ? "scale(1) translateY(0)"
          : "scale(0.88) translateY(25px)",
             
        transitionDelay:`${index *0.12}s`,

        "@keyframes cardPop": {
          from: {
            opacity: 0,
            transform: "scale(0.88) translateY(25px)",
          },
          to: {
            opacity: 1,
            transform: "scale(1) translateY(0)",
          },
        },

        "&:hover": {
          transform: "translateY(-6px)",
          boxShadow: "0 20px 45px rgba(242, 182, 99, 0.8)",
        },

        "&:hover .product-img": {
          transform: "scale(1.12)",
        },

        "&:hover .title": {
          color: "#f29c24",
        },

        "&:hover .view-btn": {
          opacity: 1,
          transform: "translateY(0)",
        },
      }}
    >
      <Box
        sx={{
          position: "relative",
          width: "100%",
          height: "280px",
          overflow: "hidden",
        }}
      >
        <Box
          className="product-img"
          sx={{
            width: "100%",
            height: "100%",
            background: `url(${cake.image})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            transition: "transform 0.6s ease",
          }}
        />
        <Box sx={{ height: '31px', width: '56px', bgcolor: 'orange', position: 'absolute', left: 242, top: 17, borderRadius: '31px' ,display:'flex',justifyContent:'center',alignItems:'center'}}>
          <Typography sx={{color:'white',fontWeight:600,fontSize:'13px'}}>₹{cake.price}</Typography>
        </Box>
        <Button
          className="view-btn"
          sx={{
            position: "absolute",
            bottom: 18,
            left: "50%",
            transform: "translate(-50%, 10px)",
            opacity: 0,

            background: "white",
            color: "#f29c24",
            borderRadius: "14px",
            px: 3,
            fontWeight: 600,
            textTransform: "none",

            transition: "all 0.35s ease",

            "&:hover": {
              background: "#fff",
            },
          }}
        >
          View Details
        </Button>
      </Box>
      <Typography
        className="title"
        variant="h5"
        sx={{ mt: 3, fontSize: "1.4rem", pl: 2, transition: "color 0.3s ease" }}
      >
        {cake.name}
      </Typography>
      <Typography sx={{ fontSize: "12px", p: 2 }}>{cake.description}</Typography>
    </Box>
  );
}
